var map = {
	"./custom-ring-speed-zh.json": [
		"7786",
		"chunk-2d0d76d4"
	],
	"./custom-ring-speed.json": [
		"4067",
		"chunk-2d0bff33"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "fa62";
module.exports = webpackAsyncContext;